<template>
  <div class="cascsder-wrapper">
    <div class="quick-select-wrapper">
      <div class="label">热门城市</div>
      <div class="items-wrap">
        <div
          v-for="item in data.hotCities"
          :key="item.code"
          class="item"
          :class="{ active: item.code === activeCode }"
          @click="onFastChoose(item.code)"
        >
          {{ item.content }}
        </div>
      </div>
    </div>
    <div class="header-wrap">
      <div class="item">省份</div>
      <div class="item">城市</div>
    </div>
    <div class="picker-wrap">
      <picker
        ref="cityPicker"
        visible-item-count="10"
        item-height="46"
        class="picker"
        :columns="columns"
        title="选择地区"
        @change="onChange"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { IQuestion, IAnswerItem, IOption } from './types';
import Picker from 'vant/lib/picker';
import 'vant/lib/picker/style';

interface IBaseInfo {
  content: string; // 原始文案
  text: string; // 选项文字，用于组件渲染
  code: string; // 选项code，用于后端数据提交
  children?: IBaseInfo[]; // 用于组件渲染子列
}

// 省前面的首字母前缀 每个首字母只出现一次（在第一个）
const prefixMap: { [key: string]: boolean } = {};
const hotCityCodeToIndexMap: { [key: string]: number[] } = {};

@Component({
  components: { Picker },
})
export default class CitySelector extends Vue {
  @Prop({}) data!: IQuestion;
  @Prop({}) answer!: IAnswerItem;

  columns: IBaseInfo[] = [];
  activeIndex = [0, 0];
  activeCode = '';

  get hotCities() {
    return this.data?.hotCities?.map((item) => item.code) || [];
  }

  mounted() {
    this.initColumns();
    this.handleInitAnswer();
  }

  initColumns() {
    // 构造出 IBaseInfo 结构
    const columns: IBaseInfo[] = [
      {
        text: '<span class="prefix"></span><span class="text placeholder">请选择</span>',
        content: '',
        code: '',
        children: [
          {
            text: '<span class="text placeholder">请选择</span>',
            content: '',
            code: '',
          },
        ],
      },
    ];
    this.data.options.forEach((option, index) => {
      columns.push(
        this.generateData({
          optionData: option,
          isLoop: true,
          parentIndex: index + 1, // placeholder 占位一个
        })
      );
    });
    this.columns = columns;
  }

  handleInitAnswer() {
    let parentIndex = -1;
    let childIndex = -1;

    try {
      // this.answer可能为undefined，此时被catch，不执行遍历查询
      const [parentCode, childCode] = this.answer.codeList!;

      parentIndex = this.columns.findIndex((item) => item.code === parentCode);
      if (parentIndex && parentIndex >= 0) {
        if (!childCode) {
          childIndex = 0;
        } else {
          const _childIndex = this.columns[parentIndex].children?.findIndex(
            (item) => item.code === childCode
          );
          _childIndex && (childIndex = _childIndex);
        }
      }
    } catch (e) {}

    if (!(parentIndex >= 0 && childIndex >= 0)) {
      parentIndex = childIndex = 0;
    }
    this.$nextTick(() => {
      this.$refs.cityPicker.setIndexes([parentIndex, childIndex]);
    });
  }
  generateData({
    optionData: { content, code, options, description },
    isLoop = false,
    parentIndex,
    childIndex = 0,
  }: {
    optionData: IOption;
    isLoop?: boolean;
    parentIndex: number;
    childIndex?: number;
  }) {
    if (this.hotCities.includes(code)) {
      hotCityCodeToIndexMap[code] = [parentIndex, childIndex];
    }

    const result: IBaseInfo = {
      content,
      code,
      text: content,
    };
    if (isLoop) {
      const contentHtml = `<span class="text">${content}</span>`;
      let prefixHtml = '<span class="prefix"></span>';

      if (description && !prefixMap[description]) {
        prefixMap[description] = true;
        prefixHtml = `<span class="prefix">${description}</span>`;
      }

      result.text = prefixHtml + contentHtml;
      if (options && Array.isArray(options)) {
        result.children = options.map((item: any, index) =>
          this.generateData({
            optionData: item,
            parentIndex,
            childIndex: index,
          })
        );
      } else {
        result.children = [{ content: '', code: '', text: '' }];
      }
    }
    return result;
  }

  onFastChoose(code: string) {
    if (hotCityCodeToIndexMap[code]) {
      this.$refs.cityPicker.setIndexes(hotCityCodeToIndexMap[code]);

      this.activeCode = code;

      this.$emit(
        'onChooseCascader',
        this.data,
        this.$refs.cityPicker.getValues()
      );
    }
  }

  onChange() {
    this.activeCode = '';
    this.$emit(
      'onChooseCascader',
      this.data,
      this.$refs.cityPicker.getValues()
    );
  }
}
</script>

<style lang="scss" scoped vars="{ ques-theme-bg, ques-theme-bg-opacity }">
$theme-color: var(--ques-theme-bg);
$theme-color-opacity: var(--ques-theme-bg-opacity);
$color-font: rgba(56, 45, 104, 0.8);

.quick-select-wrapper {
  margin-bottom: 30px;
  padding-bottom: 52px;
  border-bottom: 1px solid #e9e9f3;

  .label {
    margin-left: 10px;
    color: $color-font;
    font-size: 24px;
    line-height: 46px;
  }
  .items-wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .item {
    height: 70px;
    margin-top: 30px;
    padding: 0 42px;
    color: $color-font;

    font-size: 28px;
    line-height: 70px;
    background-color: #f5f5fb;
    border: 2px solid #f5f5fb;
    border-radius: 35px;

    &.active {
      background-color: $theme-color-opacity;
      border-color: $theme-color;
    }
  }
}

.cascsder-wrapper {
  width: 100vw;
  padding: 0 42px;
  .van-picker__columns {
    // padding-left: 96px;

    .van-picker__frame {
      // width: 666px;
      // height: 94px !important;
      background: linear-gradient(
        270deg,
        rgba(102, 95, 148, 0) 0%,
        $theme-color 51%,
        rgba(104, 84, 240, 0) 100%
      );
      opacity: 0.12;
    }

    .van-picker-column__item {
      justify-content: flex-start;
    }

    .van-picker-column:nth-child(1) {
      // padding-left: 50px;
      flex: 1;
    }
    .van-picker-column:nth-child(2) {
      // padding-left: 50px;
      flex: 1;
    }
    .van-ellipsis {
      // display: flex;
      .prefix {
        display: inline-block;
        width: 50px;
        color: $theme-color;
        font-size: 28px;
        line-height: 46px;
        opacity: 0.4;
      }
      .text {
        color: rgba(56, 45, 104, 0.8);
      }
      .placeholder {
        opacity: 0.4;
      }
    }
    .van-picker-column__item--selected {
      color: $theme-color !important;
      font-weight: 500;
      .text {
        color: $theme-color;
      }
    }
  }
}
.picker-wrap {
  max-height: 31vh;
  overflow: hidden;
  .picker {
    transform: translateY(-380px);
  }
}
.header-wrap {
  display: flex;
  align-items: center;
  height: 46px;
  margin-bottom: 24px;
  // padding-left: 170px;
  padding-left: 60px;
  color: #382d68;
  font-weight: 500;
  font-size: 28px;
  line-height: 46px;

  .item {
    flex: 1;
  }
  .item:nth-child(2) {
    padding-left: 16px;
  }
}
</style>
<style lang="scss" vars="{ques-theme-bg}">
$theme-color: var(--ques-theme-bg);
.cascsder-wrapper {
  .van-ellipsis {
    // display: flex;
    .prefix {
      display: inline-block;
      width: 50px;
      color: $theme-color;
      font-size: 28px;
      line-height: 46px;
      opacity: 0.4;
    }
    .text {
      color: rgba(56, 45, 104, 0.8);
    }
    .placeholder {
      opacity: 0.4;
    }
  }
  .van-picker-column__item--selected {
    color: $theme-color !important;
    font-weight: 500;
    .text {
      color: $theme-color;
    }
  }
}
</style>